"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@phishtool/ui");
const styled_1 = require("./styled");
const Page = ({ children }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_1.HistoryListener, {}), (0, jsx_runtime_1.jsx)(ui_1.BasicAuthLogout, {}), (0, jsx_runtime_1.jsx)(ui_1.Notification, { position: 35 }), (0, jsx_runtime_1.jsx)(styled_1.StyledPageWrapper, { children: children })] }));
exports.default = Page;
